import { Grid } from "@mui/material";
import { Text } from "../../../components/common/typography/Style";
import { ColorTheme } from "../../../styles/color";

const retrieveLocalTimezone = () => {
	let timeZone = "N/A";
	if (
		typeof Intl !== "undefined" &&
		typeof Intl.DateTimeFormat === "function"
	) {
		timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	return timeZone;
};

const EmbeddableFooter = () => {
	const localTimeZone = retrieveLocalTimezone();
	return (
		<Grid container>
			{["America/Los_Angeles"].includes(localTimeZone) && (
				<Grid item xs={12} mt={"8px"}>
					<Text
						textcolor={ColorTheme.base.white}
						size={"sm"}
						textweight={"regular"}
					>
						{
							// IMPORTANT: California Privacy Law Requirement (we got sued because of not having opt-out from external services)
						}
						This website utilizes technologies such as cookies to enable
						essential site functionality, as well as for analytics,
						personalization, and targeted advertising.{" "}
						<a
							href="#"
							onClick={() => {
								localStorage?.setItem("ext-svc-opt-out", "1");
								top.postMessage({ id: "opt-out" }, { targetOrigin: "*" });
							}}
						>
							{" "}
							Click here{" "}
						</a>{" "}
						to opt-out.
					</Text>
				</Grid>
			)}
		</Grid>
	);
};

export default EmbeddableFooter;
